<style scope>
</style>

<template>
  <section class="container">
    <orcamento-piller-cliente-edit/>
  </section>
</template>

<script>
  import OrcamentoPillerClienteEdit from './piller/OrcamentoPillerClienteEdit'

  export default {
    components: {OrcamentoPillerClienteEdit},
    created () {
      if (!this.$store.state.parametros || !this.$store.state.parametros.id) {
        this.$air.sair()
        this.$root.$emit('acessar')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/orcamento/FormClienteEdit.vue